import React from "react";
import useSwitch from "@react-hook/switch";

import {
  styled,
  Avatar,
  Box,
  Collapse,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { ChevronLeft } from "mdi-material-ui";

const shouldForwardProp = (prop) => prop !== "expanded";
const ExpandIcon = styled(ChevronLeft, { shouldForwardProp })(
  ({ expanded, theme }) => ({
    transition: theme.transitions.create("transform") + "!important",
    transform: `rotate(${expanded ? -90 : 0}deg)`,
  })
);

export default function SidebarItem({
  icon,
  title,
  titleChildren,
  startExpanded,
  unmountOnExit,
  ...props
}) {
  const [expanded, toggle] = useSwitch(startExpanded);

  return (
    <>
      <ListItem
        button
        onClick={toggle}
        sx={{ borderTop: (t) => `1px solid ${t.palette.divider}` }}
      >
        <ListItemAvatar>
          <Avatar>{icon}</Avatar>
        </ListItemAvatar>
        <ListItemText primary={title} />

        {titleChildren}

        <ExpandIcon expanded={expanded} />
      </ListItem>

      <Collapse in={expanded} unmountOnExit={unmountOnExit}>
        <Box {...props} />
      </Collapse>
    </>
  );
}

SidebarItem.defaultProps = {
  startExpanded: false,
};
